<phx-tile
  [phxClickable]="true"
  [phxBorder]="true"
  [phxBorderStates]="true"
  [phxIsUsedAsSelector]="true"
  [phxSelected]="isSelected"
  [phxSize]="phxSize"
  [phxVisible]="phxMonthPickerOpened"
  (phxVisibleChange)="onMonthPickerOpened($event)"
  [phxDropdownFor]="phxDropdown"
  (keydown.enter)="onMonthPickerOpened(true)"
  class="phx-month-picker-tile"
  >
    <i phx-icon [phxIcon]="CalendarIcon" color="currentColor" phx-tile-prefix></i>
    <span class="phx-time-picker-select-text phx-web-type-body-medium" *ngIf="phxIsRangeEnabled">
      <ng-container *ngIf="phxValueSelectRange && phxValueSelectRange.start && phxValueSelectRange.end; else noValueRange">
        {{formatMonthYear(phxValueSelectRange.start)}} - {{formatMonthYear(phxValueSelectRange.end)}}
      </ng-container>
    </span>
    <ng-container *ngIf="!phxIsRangeEnabled">
      <span *ngIf="phxValueSingeleDate; else noValue" class="phx-time-picker-select-text phx-web-type-body-medium">
        {{formatMonthYear(phxValueSingeleDate)}}
      </span>
    </ng-container>
    <ng-template #noValueRange>
      {{phxIsRangeEnabled? 'Date-range' : 'Date'}}
    </ng-template>
    <ng-template #noValue>
      Date
    </ng-template>
    <i phx-icon [phxIcon]="ChevronDownIcon" phx-tile-suffix></i>
</phx-tile>
<phx-dropdown #phxDropdown>
  <phx-month-picker-header 
    [year]="year"
    (nextYear)="onNextYear()"
    (previousYear)="onPreviousYear()">
  </phx-month-picker-header>
  <phx-month-picker-body 
    [phxYear]="year"
    [phxValue]="phxValue" 
    [phxIsRangeEnabled]="phxIsRangeEnabled" 
    (phxValueChange)="onMonthPickerChange($event)">
  </phx-month-picker-body>
  <phx-month-picker-footer
    *ngIf="phxIsRangeEnabled ? (phxValueSelectRange?.start && phxValueSelectRange?.end) : phxValueSingeleDate"
    [selectedValue]="phxIsRangeEnabled ? phxValueSelectRange : null"
    (clear)="onClear()">
  </phx-month-picker-footer>
</phx-dropdown>
